/**
 * Core Layer - Video Codec
 * Handles VP8 video encoding and decoding
 * No state management, no business logic - pure WebRTC operations
 */

/**
 * Get frame information from VP8 frame stream
 */
export function getFrameInfo(vp8FrameStream) {
    const frameInfo = {};
    const header = new DataView(vp8FrameStream.buffer);

    frameInfo.isKeyFrame = (header.getUint8(0) & 0x01) === 0;
    if (frameInfo.isKeyFrame) {
        frameInfo.width = header.getUint16(6, true) & 0x3FFF;
        frameInfo.height = header.getUint16(8, true) & 0x3FFF;
    }

    return frameInfo;
}

/**
 * Create a video encoder
 */
export function createVideoEncoder(onOutput, onError) {
    // eslint-disable-next-line no-undef
    return new VideoEncoder({
        output: onOutput,
        error: onError,
    });
}

/**
 * Configure video encoder
 */
export function configureVideoEncoder(encoder, width, height, bitrate = 1_500_000) {
    encoder.configure({
        codec: 'vp8',
        width,
        height,
        bitrate,
    });
}

/**
 * Encode a video frame
 */
export function encodeVideoFrame(encoder, canvas, timestamp, isKeyFrame) {
    // eslint-disable-next-line no-undef
    const frame = new VideoFrame(canvas, {timestamp});
    encoder.encode(frame, {keyFrame: isKeyFrame});
    frame.close();
}

/**
 * Create a video decoder
 */
export function createVideoDecoder(onOutput, onError) {
    // eslint-disable-next-line no-undef
    return new VideoDecoder({
        output: onOutput,
        error: onError,
    });
}

/**
 * Configure video decoder
 */
export function configureVideoDecoder(decoder) {
    decoder.configure({
        codec: "vp8",
    });
}

/**
 * Decode a video chunk
 */
export function decodeVideoChunk(decoder, dataBuffer, isKeyFrame, timestamp) {
    // eslint-disable-next-line no-undef
    const chunk = new EncodedVideoChunk({
        type: isKeyFrame ? 'key' : 'delta',
        timestamp,
        data: dataBuffer,
        byteLength: dataBuffer.length
    });

    decoder.decode(chunk);
}

/**
 * Close video encoder
 */
export function closeVideoEncoder(encoder) {
    if (encoder) {
        encoder.close();
    }
}

/**
 * Close video decoder
 */
export function closeVideoDecoder(decoder) {
    if (decoder) {
        decoder.close();
    }
}
